// extracted by mini-css-extract-plugin
export default {"Tag":"NameTag_Tag__RDg0T","DownloadDiv":"NameTag_DownloadDiv__MptAx","Download":"NameTag_Download__C2L-4"};